export function base64ToBlob(value: string, mimeType: string) {
  const byteString = atob(value);
  const ab = new ArrayBuffer(byteString.length);
  const ia = new Uint8Array(ab);

  for (let i = 0; i < byteString.length; i++) {
    ia[i] = byteString.charCodeAt(i);
  }

  return new Blob([ab], { type: mimeType });
}

// convert blob to base64 string
export function blobToBase64(blob: Blob) {

  if (blob.size === 0) {
    return Promise.resolve('');
  }

  return new Promise<string>((resolve, reject) => {
    const reader = new FileReader();

    reader.onload = () => {
      const base64 = reader.result as string;
      resolve(base64.split(',')[1]);
    };

    reader.onerror = reject;
    reader.readAsDataURL(blob);
  });
}
